<template>
  <QHeader>
    <QToolbar
      v-if="$q.screen.gt.sm"
      class="h-10 bg-[#0e1015]"
    >
      <div class="w-full">
        <div class=" flex justify-end items-center">
          <UserNav v-if="authStore.isLoggedIn" />
          <div
            v-else
            class="grid grid-cols-14 w-full"
          >
            <div class="col-span-2" />
            <LoginNav
              class="col-span-10 justify-self-end"
            />
          </div>
        </div>
      </div>
    </QToolbar>
    <QToolbar class="grid grid-cols-14 h-16 bg-[#090A0F] shadow-md shadow-[#C1C1C1]">
      <div
        v-if="$q.screen.gt.sm"
        class="col-span-2"
      />
      <div class="col-span-14 md:col-span-10 flex flex-nowrap items-center justify-between">
        <div class="flex flex-nowrap items-center gap-1 md:gap-4">
          <QBtn
            v-if="$q.screen.lt.md"
            flat
            dense
            round
            icon="menu"
            aria-label="Menu"
            size="18px"
            @click="configStore.toggleLeftDrawer()"
          />
          <Logo
            class="w-25 md:w-35"
            clickable
          />
        </div>
        <div class="flex flex-nowrap items-center gap-2 md:gap-4">
          <AppNav v-if="$q.screen.gt.sm" />
        </div>
        <div
          v-if="$q.screen.lt.md"
          class="flex flex-nowrap items-center gap-2 md:gap-4"
        >
          <LoginNav v-if="!authStore.isLoggedIn" />
          <div
            v-else
            class="flex items-center gap-2"
          >
            <Avatar />
            <QBtn
              v-if="authStore.isLoggedIn && $q.screen.lt.md"
              dense
              unelevated
              icon="shopping_cart"
              class="text-light-icon"
              size="md"
              @click="configStore.toggleRightDrawer()"
            >
              <QBadge
                v-if="cartStore.items.length > 0"
                floating
                color="red"
                rounded
              >
                {{ cartStore.items.length }}
              </QBadge>
            </QBtn>
          </div>
        </div>
      </div>
    </QToolbar>
    <QToolbar
      v-if="$q.screen.lt.sm && authStore.isLoggedIn"
      class="!h-6 bg-dark-1"
    >
      <Profile />
    </QToolbar>
  </QHeader>
</template>

<script setup>
import AppNav from './AppNav.vue'
import UserNav from './UserNav.vue'
import LoginNav from './LoginNav.vue'
import Logo from '@/components/Logo.vue'
import Avatar from "./Avatar.vue"
import Profile from "./Profile.vue"
import { useAuthStore } from "@/stores/auth"
import { useConfigStore } from "@/stores/config"
import { useCartStore } from "@/stores/cart"

const authStore = useAuthStore()
const configStore = useConfigStore()
const cartStore = useCartStore()
</script>
<style>
.q-toolbar {
  min-height: 20px;
}
</style>